import React from 'react'
import { Graphic } from '../../ui'
import { verifiedTagsIconMap } from '../Graphic/graphics'

export const TagGraphic = ({ uniqueId, ...props }) => {
  const graphicId = verifiedTagsIconMap[uniqueId] || 'dataverified_membership'

  return <Graphic name={['VerifiedTags', graphicId]} size={32} {...props} />
}
